import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'emptyFieldPipe',
    standalone: false
})
export class EmptyFieldPipe implements PipeTransform {
  public transform(input: any, args?: any): any {
    return (input === null || input === void 0 || input === "") ? args.blankFieldValue : input;
  }
}
